var LoaderTemplate = require('../partials/loadingAnimation.hbs');

var Loader = function(props) {
	if (!props.className) 
		props.className = 'loading-icon';
	if (!props.label) 
		props.label = '_LOADING_';

	this.start = function() {
		if (!props.parentElem)
			console.error('Please provide parent element to put "loader" in');

		var req = {
			noOfLoadingIcons: Array.apply(null, (new Array(5))).map(function(){
		      	return {
		      		className: props.className
		      	}
	      	}),
	      	label: props.label
	    };
		req['wrapperClass'] = 'freeze-panel-wrapper';

		props.parentElem.html(LoaderTemplate(req));
	};
	this.stop = function() {
		props.parentElem.html('');
	}
}

module.exports = Loader;